import { Search } from '@mui/icons-material'
import { Alert, AlertProps, AlertTitle, Typography, TypographyProps, useTheme } from '@mui/material'
import { ReactNode } from 'react'

interface EmptyStateProps extends Omit<AlertProps, 'title' | 'slotProps'> {
  icon?: ReactNode
  title: ReactNode
  slotProps?: {
    title: Omit<TypographyProps, 'children'>
  }
}

export default function EmptyState({
  icon,
  title,
  children,
  slotProps,
  sx,
  ...props
}: EmptyStateProps) {
  const theme = useTheme()

  return (
    <Alert
      severity="info"
      icon={icon ? icon : <Search sx={{ fontSize: 42 }} />}
      sx={{
        // backgroundColor: theme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        p: 8,
        minHeight: 220,
        '& .MuiAlert-icon': {
          minWidth: 'auto',
          mr: 0,
          p: 0
        },
        '& .MuiAlert-message': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          p: 0
        },
        ...sx
      }}
      {...props}
    >
      {typeof icon === 'string' ? (
        <AlertTitle variant="h6" sx={{ textAlign: 'center', width: '100%' }}>
          {title}
        </AlertTitle>
      ) : (
        title
      )}

      {children}
    </Alert>
  )
}
